import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Work from "./pages/Work";
import WorkCategory from "./pages/WorkCategory";
import CV from "./pages/CV";
import Book from "./pages/Book";

// React Router doesn't scroll to #hash targets on client-side navigation
// the way a full page load does, so cross-page anchor links (e.g. Home's
// highlight cards linking to /work#lcr-summit) land at the top of the page
// instead of the right section. This fixes that.
const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const scrollToTarget = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return true;
        }
        return false;
      };
      if (!scrollToTarget()) {
        const timeout = setTimeout(scrollToTarget, 100);
        return () => clearTimeout(timeout);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
};

const App = () => (
  <BrowserRouter>
    <div className="flex min-h-screen flex-col bg-paper text-ink">
      <Nav />
      <ScrollToHash />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/work/:category" element={<WorkCategory />} />
          <Route path="/cv" element={<CV />} />
          <Route path="/book" element={<Book />} />
        </Routes>
      </div>
      <Footer />
    </div>
  </BrowserRouter>
);

export default App;
